import type { RubricCriterion, RubricLayout } from './types'

/** Missing layout means the original order. Never hide a criterion because metadata is old. */
export function rubricSections(ids: string[], layout?: RubricLayout): RubricLayout {
  const available = new Set(ids)
  const seen = new Set<string>()
  const sections = (layout ?? []).map(s => ({ ...s, criterion_ids: s.criterion_ids.filter(id => {
    if (!available.has(id) || seen.has(id)) return false
    seen.add(id)
    return true
  }) }))
  const missing = ids.filter(id => !seen.has(id))
  if (missing.length || !sections.length) {
    const unsectioned = sections.find(s => s.section_id === 'unsectioned')
    if (unsectioned) unsectioned.criterion_ids = [...unsectioned.criterion_ids, ...missing]
    else sections.push({ section_id: 'unsectioned', title: '', criterion_ids: missing })
  }
  return sections
}

export function sectionsFor(rubric: RubricCriterion[], layout?: RubricLayout) {
  return rubricSections(rubric.map(c => c.criterion_id), layout)
}
